import { combineReducers } from 'redux';

const defaultOpenResetPassModal = false;
const openResetPassModal = (state = defaultOpenResetPassModal, action) => {
  switch (action.type) {
    case 'TOGGLE_RESET_PASS_MODAL':
      return action.isOpen;
    default:
      return state;
  }
};

export default combineReducers({
  openResetPassModal,
});
